import { gql } from '@apollo/client';

export const REMOVE_OPENAI_KEY = gql`
    mutation RemoveOpenAIKey($data: RemoveOpenAIKeyInput!) {
        removeOpenAIKey(data: $data) {
            __typename
            ... on SetOpenAIKeySuccess {
                success
                status
            }
            ... on OpenAIKeyError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
